import { Link } from "react-router-dom";
import { FoxMark, Wordmark } from "@/components/Logo";

/**
 * Shared public footer with legal links + FOXVISITS LTD attribution.
 * Used on Landing and all public pages (Privacy, Terms, Contact, GetStarted).
 */
export default function PublicFooter() {
    return (
        <footer className="border-t border-line bg-white" data-testid="public-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <FoxMark size={28} color="#111111" />
                            <Wordmark className="text-base" />
                        </div>
                        <p className="text-sm text-ink2 leading-relaxed max-w-xs">
                            AI recipe articles, fully formatted, auto-published to your WordPress.
                        </p>
                    </div>
                    <div>
                        <div className="overline text-xs mb-3">Product</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/get-started" className="hover:text-klein" data-testid="footer-get-started">Getting started</Link></li>
                            <li><Link to="/register" className="hover:text-klein" data-testid="footer-register">Create account</Link></li>
                            <li><Link to="/login" className="hover:text-klein" data-testid="footer-login">Sign in</Link></li>
                            <li><Link to="/contact" className="hover:text-klein" data-testid="footer-contact">Contact &amp; support</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline text-xs mb-3">Legal</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/privacy" className="hover:text-klein" data-testid="footer-privacy">Privacy policy</Link></li>
                            <li><Link to="/terms" className="hover:text-klein" data-testid="footer-terms">Terms of service</Link></li>
                            <li><a href="mailto:contact@recipefox.site" className="hover:text-klein" data-testid="footer-support-email">contact@recipefox.site</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline text-xs mb-3">Features &amp; guides</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/wp-recipe-maker" className="hover:text-klein" data-testid="footer-wprm">WP Recipe Maker</Link></li>
                            <li><Link to="/wp-delicious" className="hover:text-klein" data-testid="footer-wpd">WP Delicious</Link></li>
                            <li><Link to="/recipe-listicles" className="hover:text-klein" data-testid="footer-listicles">Recipe listicles</Link></li>
                            <li><Link to="/recipefox-vs-chatgpt" className="hover:text-klein" data-testid="footer-vs-chatgpt">RecipeFox vs ChatGPT</Link></li>
                            <li><Link to="/pricing" className="hover:text-klein" data-testid="footer-pricing">Pricing</Link></li>
                            <li><Link to="/faq" className="hover:text-klein" data-testid="footer-faq">FAQ</Link></li>
                            <li><Link to="/guides" className="hover:text-klein" data-testid="footer-guides">Guides</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="pt-6 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ink2 font-mono">
                    <div>RecipeFox AI &copy; 2026. All rights reserved.</div>
                    <div data-testid="footer-foxvisits">Proudly built by <span className="text-ink font-semibold">FOXVISITS LTD</span>, Scotland</div>
                </div>
            </div>
        </footer>
    );
}
